import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PtImageMappingService } from './../../../../../service/pt-image-mapping.service';

@Component({
	selector: 'app-s-copy-image',
	templateUrl: './s-copy-image.component.html',
	styleUrls: ['./s-copy-image.component.scss']
})
export class SCopyImageComponent implements OnInit {

	public copyImageRows: Array<object> = [];
	public mailingID: string = '';
	public isSelectedAll: boolean = false;
	public mailingRows: Array<object> = [];
	public isCopyBtnDisable: boolean = true;
	public errorList: Array<string> = [];

	constructor(private ptImageMappingService: PtImageMappingService,
		public dialogRef: MatDialogRef<SCopyImageComponent>,
		@Inject(MAT_DIALOG_DATA) public dailogData: any) {
		this.mailingID = this.dailogData.mailingID;

		for (let i = 1; i <= 10; i++) {
			this.mailingRows.push({
				index: i,
				value: ''
			});
		}
	}

	ngOnInit(): void {
		// SERVER CALL AND GET COPY DATA LIST
		this.ptImageMappingService.getSCopyDataList(this.mailingID).subscribe((result: Array<object>) => {
			this.copyImageRows = result;
			this.copyImageRows.forEach((item: any) => item.isSelected = false);
		});
	}

	// ON CHANGE SPECIMEN AND POPULATE THE DATA AND SET THE BUTON ENABLE OR DISABLE.
	onChangeSpecimen = (event, image) => {
		if (event.target.checked) {
			if(image == 'all'){
				this.copyImageRows.forEach((item: any) => item.isSelected = true)
			}else{
				image.isSelected = true;
			}
		} else {
			if (image == 'all') {
				this.copyImageRows.forEach((item: any) => item.isSelected = false);
			} else {
				image.isSelected = false;
				this.isSelectedAll = false;
			}
		}

		this.isCopyButtonDisabled();
	}

	// ON KEY UP MAILING TO SET BTTON ENALBLE OR DISABLE.
	onKeyUpMailing = (event) => {
		const mailingRows = this.mailingRows.find((item: any) => item.value !== '');
		const copyImageRows = this.copyImageRows.find((item: any) => item.isSelected == true);
		this.isCopyBtnDisable = (mailingRows !== undefined && copyImageRows !== undefined) ? false : true;
	}

	// COMMON - TO SET THE BUTTON DISABLE OR ENABLE.
	isCopyButtonDisabled = () => {
		const mailingRows = this.mailingRows.find((item: any) => item.value !== '');
		const copyImageRows = this.copyImageRows.find((item: any) => item.isSelected == true);
		this.isCopyBtnDisable = (mailingRows !== undefined && copyImageRows !== undefined) ? false : true;
	}

	// CLICK ON COPY IMAGE BUTTON TO ONE SPECIMEN TO SELECTED SPECIMEN.
	clickCopyImageButton = () => {
		const editedMailingRows = [];
		const editedCopyImageRows = [];
		this.errorList = [];
		this.mailingRows.forEach((item: any) => { if (item.value !== '') { editedMailingRows.push((item.value).toUpperCase()) } });
		this.copyImageRows.forEach((item: any) => {
			if (item.isSelected == true) {
				editedCopyImageRows.push({
					specimenCode: item.specimenCode,
					mailingCode: item.mailing
				});
			}
		});

		// FOR POST METHOD
		const requestData = {
			toMailingU: editedMailingRows,
			selectedSpecimen: editedCopyImageRows,
			selectedImages: this.copyImageRows.filter((item: any) => item.isSelected == true)
		}

		// TO VALIDATE THE COPY IMAGE BASED ON MAILING ID.
		this.ptImageMappingService.validateCopyImage(this.mailingID, requestData).subscribe((result: any) => {
			if (!result.isValid && result.errorMsgs.length > 0) {
				this.errorList = result.errorMsgs;
			}
			if (!result.isValid && result.warningMsgs.length > 0) {
				this.errorList = result.warningMsgs;
			}
			if (result.copySuccessful) {
				this.dialogRef.close({
					success: true,
					data: requestData
				});
			}
		});
	}
}